import React from "react";

const MonthTabLabel = React.memo(({ monthName, invoiceCount, year, invoiceAmount }) => {
    const isLoading = invoiceCount === null;
    const hasInvoices = invoiceCount > 0;
    
    const formatAmount = (amount) => {
        if (!amount) return "0 €";
        
        if (amount >= 1000000) {
            return (amount / 1000000).toFixed(1) + "M €";
        } else if (amount >= 1000) {
            return (amount / 1000).toFixed(1) + "k €";
        } else {
            return amount.toFixed(0) + " €";
        }
    };

    return (
        <div className="tab">
            <span className="tab__name">
                {monthName}.
            </span>
            <span className={`tab__content ${hasInvoices ? 'tab__content--active' : ''} ${isLoading ? 'tab__content--loading' : ''}`}>
                {isLoading ? "..." : formatAmount(invoiceAmount)}
            </span>
        </div>
    );
});

export default MonthTabLabel;
